import { Button, Typography } from "@mui/material";
import theme from "assets/styles/themes";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";
import { useIntl } from "react-intl";

const ClearFilterButton = ({ onClick, isDisabled }: { onClick: () => void; isDisabled?: boolean }) => {
    const intl = useIntl();

    return (
        <Button
            size="small"
            startIcon={<CustomIcon icon={icons.circledTimes} />}
            disabled={isDisabled}
            onClick={onClick}
            sx={{
                padding: 0,
                height: 36,
                fontSize: 12,
                letterSpacing: "1.25px",
                color: theme.palette.primary.dark,
                "&.Mui-disabled": {
                    color: theme.palette.text.disabled,
                },
                "& .MuiButton-startIcon>*:nth-of-type(1)": {
                    fontSize: 12,
                },
                "& .MuiButton-startIcon": {
                    marginRight: 0.7,
                },
            }}
        >
            {intl.formatMessage({ id: "advancedpeersearch.clearFilters" })}
        </Button>
    );
};

export default ClearFilterButton;
